module.exports = __webpack_public_path__ + "static/media/Tips_and_Tools-Plan_Vs_Device.1b40302b.svg";